import React, { useState, useContext } from "react";
import { Menu, Container, Header } from "semantic-ui-react";
import Thales_logo from "../logo/Thales_logo.PNG";
import { Link } from "react-router-dom";
import { ContextProvider } from "../providers/app.provider";

const NavBar = () => {
  const [activeItem, setActiveItem] = useState("Home");
  const { indicator } = useContext(ContextProvider);
  const handleItemClick = (e, { name }) => setActiveItem(name);

  return (
    <Container>
      <Menu style={{ backgroundColor: "#0c0d29" }} inverted size="massive">
        <Menu.Item>
          <img src={Thales_logo} alt="Thales" size="medium" />
        </Menu.Item>
        <Menu.Item
          name="Home"
          active={activeItem === "Home"}
          onClick={handleItemClick}
          as={Link}
          to="/"
        />
        {indicator.length !== 0 ? (
          <Menu.Item>
            <Header size="medium" inverted>
              {indicator}
            </Header>
          </Menu.Item>
        ) : null}
      </Menu>
    </Container>
  );
};
export default NavBar;
